import { LocalStorageService } from 'services/application/storage/localStorage/LocalStorageService';

export default {
	'services.LocalStorageService': {
		factory: () => LocalStorageService,
	},
};
